const TYPES = {
  RolloutService: Symbol.for("RolloutService"),
  RolloutTargetService: Symbol.for("RolloutTargetService"),
  ApiService: Symbol.for("ApiService"),
  ToastService: Symbol.for("ToastService")
}
export {TYPES};
